<template>
  <footer>
    <div class="container">
      <div class="footer-content">
        <div class="footer-about">
          <a
            href="#"
            class="footer-logo"
          >
            <img
              src="/images/logo.png"
              alt="E3"
            >
          </a>
          <p>AI驱动的硬件设计平台，致力于让硬件设计像软件一样便捷，赋能创新者实现无限创意。</p>
          <div class="social-links" />
        </div>
        <div>
          <h4 class="footer-heading">
            产品
          </h4>
          <ul class="footer-links">
            <li><a href="#">功能特性</a></li>
            <li><a href="#">解决方案</a></li>
            <li><a href="#">设计案例</a></li>
            <li><a href="#">版本更新</a></li>
            <li><a href="#">定价</a></li>
          </ul>
        </div>
        <div>
          <h4 class="footer-heading">
            资源
          </h4>
          <ul class="footer-links">
            <li><a href="#">文档中心</a></li>
            <li><a href="#">教程视频</a></li>
            <li><a href="#">博客</a></li>
            <li><a href="#">API文档</a></li>
            <li><a href="#">社区论坛</a></li>
          </ul>
        </div>
        <div>
          <h4 class="footer-heading">
            公司
          </h4>
          <ul class="footer-links">
            <li><a href="#">关于我们</a></li>
            <li><a href="#">加入我们</a></li>
            <li><a href="#">联系我们</a></li>
            <li><a href="#">合作伙伴</a></li>
            <li><a href="#">新闻中心</a></li>
          </ul>
        </div>
      </div>
      <div class="copyright">
        &copy; 2025 DesignPulse. 保留所有权利。
      </div>
    </div>
  </footer>
</template>

<script setup></script>

<style scoped>
footer {
  background: var(--secondary);
  color: white;
  padding: 60px 0 30px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 50px;
}

.footer-logo {
  margin-bottom: 20px;
  display: inline-block;
}

.footer-logo img {
  width: 96px;
  height: 72px;
  display: block;
  object-fit: contain;
}

.footer-about p {
  color: #94a3b8;
  margin-bottom: 20px;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-links a {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  transition: var(--transition);
}

.social-links a:hover {
  background: var(--primary);
  transform: translateY(-3px);
}

.footer-heading {
  font-size: 18px;
  margin-bottom: 25px;
  position: relative;
}

.footer-heading::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 40px;
  height: 3px;
  background: var(--primary);
}

.footer-links {
  list-style: none;
}

.footer-links li {
  margin-bottom: 15px;
}

.footer-links a {
  color: var(--gray-400);
  text-decoration: none;
  transition: var(--transition);
}

.footer-links a:hover {
  color: var(--primary);
  padding-left: 5px;
}

.copyright {
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #334155;
  color: #94a3b8;
  font-size: 14px;
}
</style>
